const faker = require('faker');
import { Factory } from 'miragejs'

export const coinFactory = Factory.extend({
  id() {
    return faker.datatype.uuid()
  },
  program_name() {
    return faker.fake('{{name.findName}}')
  },
  program_image() {
    return faker.image.imageUrl()
  },
  balance() {
    return faker.datatype.number({ max: 100 })
  }
})



// WEBPACK FOOTER //
// ./src/mocks/factories/coinFactory.js